// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-pano{margin:0;padding:0;border:0;overflow:hidden}.v-pano,body,html{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
